import React from 'react'
import styled from 'styled-components'

export const ModalBody = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 5px;
`

export const ModalFooter = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 5px;
    flex: 1;
`

export const UL = styled.ul`
  padding: 5px;
`

export const LI = styled.li``

const WrapperListItem = styled.div`
  display: flex;
  justify-content: space-between;
  flex: 1;
`

const Label = styled.span`
  flex: 1;
`

const Description = styled.span`
  flex: 1;
  overflow: auto;
  margin-bottom: 5px;
`

export const ListItem = ({ label, description }) => (
  <WrapperListItem>
    <Label>{label}</Label>
    <Description>{description}</Description>
  </WrapperListItem>
)